import { Customer_Contacts, Requirements_ECommunicationContractualAccount } from 'data/endpoints';
import ContactDTO from 'features/customer/dtos/ContactDTO';
import IRequirementCreateService from 'features/requirements/services/IRequirementCreateService';
import PageCard from 'features/shared/components/card/PageCard';
import PagedDataResultDTO from 'features/shared/dtos/PagedDataResultDTO';
import { useForm } from 'features/shared/forms/hooks/useForm';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import IAppState from 'infrastructure/store/IAppState';
import React from 'react';
import { useSelector } from 'react-redux';
import BasicInfoSubFormSection from '../basicInfoSubForm/BasicInfoSubFormSection';
import { useQuery } from 'data/hooks/useQuery';
import DataQuery from 'data/DataQuery';
import { getCustomerContactsParams, getQueryParams } from 'features/shared/helpers/queryParams';
import ContractualAccountDTO from 'features/contracts/dtos/ContractualAccountDTO';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import ContractualAccountSelect from 'features/requirements/components/transitionToEmailComForm/ContractualAccountSelect';
import AvailableEmailSelect, { SelectedValue } from 'features/requirements/components/transitionToEmailComForm/AvailableEmailSelect';
import { formValidations } from './transitionToEmailComFormValidation';
import { useTranslation } from 'react-i18next';
import { openRequirementResultDialog } from 'features/requirements/helpers/requirementResultDialogHelper';

const TransitionToEmailComFormSection = () => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // DI
  const createService = useInjection<IRequirementCreateService>(IocTypes.RequirementCreateService);

  // store
  const customer = (useSelector<IAppState, CustomerState>((store) => store.customer)).customer;

  // fetch data
  let accountsQuery: DataQuery = {url: Requirements_ECommunicationContractualAccount, params: getQueryParams("customerId", customer.customerId!)};
  const { data: contractualAccounts, loadStatus: accountsStatus } = useQuery<ContractualAccountDTO[]>(accountsQuery, [], [customer]);
  // TODO: pokud bude mít zákazník > 100 emailů - nebude fungovat (aktuálně má zákazník na prod. max. 77 emailů)
  let emailQuery: DataQuery = {url: Customer_Contacts, routeParams: getRouteParams("customerId", customer.customerId!), params: getCustomerContactsParams("Email", 100)};
  const { data: emails } = useQuery<PagedDataResultDTO<ContactDTO>>(emailQuery, {count: 0, result: []}, [customer]);

  // form hook
  const { values, errors, bindField, bindUncontrolledField, valideteForm, validateFormField, setFormValue, setValidationRule  } = useForm({
    initialValidations: formValidations()
  });

  // handlers
  const submitFormHandler = async (e: React.FormEvent) => {
    e.preventDefault();

    if (valideteForm()) {
      let result = await createService.createRequirement("PRECHODEMAILKOMUNIKACE", values);
      openRequirementResultDialog(false, {
        response: result,
        moreInfoMessage:
          values["DESC_TMNOVYEMAIL"] !== ""
            ? tLabels("transitionToEmailComFormSection.successMessage")
            : undefined
        },
        undefined,
        true
      );
    }
  };

  const contractualAccountChangeHandler = (contractulAccountIdsCsv: string) => {
    setFormValue("DESC_TMSEZNAMSU", contractulAccountIdsCsv); 
    validateFormField("DESC_TMSEZNAMSU", contractulAccountIdsCsv);
  }

  const emailChangeHandler = (email: SelectedValue) => {
    setFormValue("email", email.option.label);
    validateFormField("email", email.option.label);

    switch (email.action) {
      case "select":
        setFormValue("DESC_TMSTAVEMAIL", email.option.value); 
        setFormValue("DESC_TMNOVYEMAIL", "");  
        break;
      case "create":
        setFormValue("DESC_TMNOVYEMAIL", email.option.value);
        setFormValue("DESC_TMSTAVEMAIL", ""); 
        break;
    }   
  }

  // render
  return (
    <NoContentWrapper
      data={contractualAccounts}
      loadStatus={accountsStatus}
      noContentInfo={tLabels("transitionToEmailComFormSection.contractualAccountNotFound")}
      noContentAsAlert
    >
      <form onSubmit={submitFormHandler}>
        <PageCard title={tLabels("transitionToEmailComFormSection.cardTitle")} bodyClassName="pt-4 px-4">
          <div className="row no-gutters mx-n2">
            <div className="col-lg-6 px-2">
              <ContractualAccountSelect 
                name="DESC_TMSEZNAMSU"
                contractualAccounts={contractualAccounts}
                onChange={contractualAccountChangeHandler}
                errors={errors}
              />
            </div>
            <div className="col-lg-6 px-2">
              <AvailableEmailSelect 
                name="email"
                emails={emails.result}
                onChange={emailChangeHandler}
                errors={errors}
              />
            </div>
          </div>       
        </PageCard>
  
        <BasicInfoSubFormSection
        bindField={bindField}
        bindUncontrolledField={bindUncontrolledField}
        errors={errors}
        setValidationRule={setValidationRule}
      />
  
        <button type="submit" className="btn btn-primary px-3 py-2">{tLabels("transitionToEmailComFormSection.sendRequirement")}</button>
      </form>
    </NoContentWrapper>
  );
}

export default TransitionToEmailComFormSection;
